import React, {FC} from 'react';
import styled from 'styled-components';

import {
  SettingsSearchDropdownContent,
  SettingsSearchDropdownItem,
  SettingsSearchDropdownItemLeftIcon,
  SettingsSearchDropdownSubtitle,
  SettingsSearchDropdownTitle,
} from './settingsSearchCommon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';

/*
 * Props.
 */

interface SettingsSearchDropdownIntegrationItemProps extends SettingsSearchDropdownItemBaseProps {
  name: string;
  type: string;
  description: string;
}

/*
 * Style.
 */

interface IntegrationIconStyleProps {
  $integrationIcon: string;
}
const StyledIntegrationIconDiv = styled.div<IntegrationIconStyleProps>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-image: url(${(p) => p.$integrationIcon});
  background-size: 32px 32px;
  background-position: center;
`;

/*
 * Component.
 */

export const SettingsSearchDropdownIntegrationItem: FC<SettingsSearchDropdownIntegrationItemProps> = (
  props,
) => {
  const {onSelect, description, type, name} = props;

  return (
    <SettingsSearchDropdownItem checkmarkLabel={name} onSelect={onSelect}>
      <SettingsSearchDropdownItemLeftIcon>
        <StyledIntegrationIconDiv
          $integrationIcon={`/api/1/integration_types/${type}/public/icons/card.svg`}
        />
      </SettingsSearchDropdownItemLeftIcon>
      <SettingsSearchDropdownContent>
        <SettingsSearchDropdownTitle>{name}</SettingsSearchDropdownTitle>
        <SettingsSearchDropdownSubtitle>{description}</SettingsSearchDropdownSubtitle>
      </SettingsSearchDropdownContent>
    </SettingsSearchDropdownItem>
  );
};
